import { useState, useEffect } from 'react';
import type { SandboxGroup } from '../types/sandbox';
import { supabase } from '../lib/supabase';
import { MOCK_GROUPS } from '../lib/mock-data';

export function useGroups() {
  const [groups, setGroups] = useState<SandboxGroup[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        if (supabase) {
          const { data } = await supabase
            .from('sandbox_groups')
            .select('*')
            .order('member_count', { ascending: false });
          setGroups((data || []) as SandboxGroup[]);
        } else {
          setGroups(MOCK_GROUPS);
        }
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return { groups, loading };
}

export function useGroup(slug?: string) {
  const [group, setGroup] = useState<SandboxGroup | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) {
      setGroup(null);
      setLoading(false);
      return;
    }

    const load = async () => {
      setLoading(true);
      try {
        if (supabase) {
          const { data } = await supabase
            .from('sandbox_groups')
            .select('*')
            .eq('slug', slug)
            .single();
          setGroup(data as SandboxGroup);
        } else {
          const mock = MOCK_GROUPS.find(g => g.slug === slug);
          setGroup(mock || null);
        }
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug]);

  return { group, loading };
}
